import getSessions from '../../modules/sessions/actions/getSessions';

export default store => ({
  path: 'sessions',
  getIndexRoute(nextState, callback) {
    require.ensure([], (require) => callback(null, { component: require('./containers/ListContainer').default }));
  },
  getChildRoutes(location, callback) {
    // do asynchronous stuff to find the child routes
    require.ensure([], (require) => {
      const routes = require('./routes').default(store);
      callback(null, routes);
    });
  },
  onEnter() {
    store.dispatch(getSessions());
  },
});



// WEBPACK FOOTER //
// ./src/routes/sessions/index.js